import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4zl0felcyb: FaireBrandEntity = {
  token: "b_4zl0felcyb",
  type: "brand",
  name: "Brooklyn Brittle",
  avatarUrl:
    "https://cdn.faire.com/fastly/ef15c53a60013545bc19680fe572e9762e35283040cb3602621ad59632f2a91f.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/2c5c99edda42bb17cae0e3d555ced441930f91d22703c954e2dc931f7479a401.png",
  logoUrl:
    "https://cdn.faire.com/fastly/ef15c53a60013545bc19680fe572e9762e35283040cb3602621ad59632f2a91f.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2c5c99edda42bb17cae0e3d555ced441930f91d22703c954e2dc931f7479a401.png",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 84,
  isTopShop: true,
  isInsider: true,
  description:
    "About Brooklyn Brittle\n\nCrafted for Moments Worth Savoring.\n\nBrooklyn Brittle was born from the idea that the best moments in life are often the smallest—\na quiet pause, a shared laugh, and a bite of something unforgettable.\n\nInspired by Italy’s love for simple, high quality ingredients, our artisan style cookie brittle delivers a signature buttery crunch and bold, memorable flavors. It’s a product that keeps customers coming back and one that turns everyday shelf space into something special.\n\n\nWhy Retailers Choose Brooklyn Brittle\n\nAs a store owner, you want products that don’t just sit pretty but actually sell.\n\nHere’s why Brooklyn Brittle delivers:\n✅ Stands Out on Shelves – Bright, colorful packaging grabs attention and drives impulse buys\n✅ Drives Repeat Sales – Bold flavors and a crave worthy crunch customers remember\n✅ Cross Sells Easily – Pairs perfectly with wine, coffee, cheese, and gourmet gift baskets\n✅ Fast Turnover, Strong Margins – A premium product with a proven ROI\n\n\nThe Heart Behind the Brittle\n\nThis isn’t just a snack. It’s a story.\nRooted in a cherished family recipe, Brooklyn Brittle brings back the warmth of togetherness, one crunchy bite at a time. Whether it’s served with espresso, gifted to a friend, or tucked into a lunchbox, it’s made for connection\n\nStock Brooklyn Brittle today and bring your customers a one of a kind treat they’ll be back for again and again.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:54.252Z",
    importedBy: "entity-db-cli",
  },
};
